import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { Select, message } from "antd";
import ReportJewelryReportService from "../../../services/reports-Jewelry-service";
import ReportScaffold from "../../ChartsGroup/DiamondReportsCharts/_shared/ReportScaffold";
import { exportChartPdf } from "../../ChartsGroup/DiamondReportsCharts/_shared/exportChartPdf";
import { BlobToDownloadFile } from "../../../helper/commanFunction";
import { METAL_TYPE_CONFIG } from "./_shared/jewelryReportConfigs";
import { isValidMetalType } from "./_shared/isValidMetalType";
import JewelryDetailSearchTable from "./_shared/JewelryDetailSearchTable";
import { extractDealerIds, fetchPriorPeriodTotalClicks } from "./_shared/jewelryHelpers";

const { Option } = Select;

const JewelryMetalTypeReportMain = () => {
  const { t } = useTranslation();
  const loginDetials = useSelector((state) => state.loginReducer);

  const [dealerId, setDealerId] = useState();
  const [forDealer, setForDealer] = useState("");
  const [dealerMembershipType, setDealerMembershipType] = useState("");
  const [dataRangeFrom, setDataRangeFrom] = useState(moment().subtract(30, "days").format("YYYY-MM-DD"));
  const [dataRangeTo, setDataRangeTo] = useState(moment().format("YYYY-MM-DD"));
  const [vendorIds, setVendorIds] = useState([]);
  const [retailerIds, setRetailerIds] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [retailerList, setRetailerList] = useState([]);
  const [metalTypeData, setMetalTypeData] = useState([]);
  const [totalClicks, setTotalClicks] = useState(0);
  const [loading, setLoading] = useState(false);
  const [refetchToken, setRefetchToken] = useState(0);
  const [filterMetalTypeId, setFilterMetalTypeId] = useState("");
  const [filterMetalColorId, setFilterMetalColorId] = useState("");
  const [pdfLoading, setPdfLoading] = useState(false);
  const [activityPdfLoading, setActivityPdfLoading] = useState(false);
  const [chartType, setChartType] = useState("doughnut");
  const [priorTotalClicks, setPriorTotalClicks] = useState(null);

  useEffect(() => {
    if (loginDetials?.loginDetials?.responseData?.logInSucceeded) {
      const id = loginDetials.loginDetials.responseData.dealerId;
      setDealerId(id);
      handleCheckDealermembers(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCheckDealermembers = (id) => {
    ReportJewelryReportService.GetForDealer({ dealerID: id }).then((response) => {
      if (response.data.message === "Success") {
        const memberType = loginDetials.loginDetials.responseData.dealerMemberTypeName;
        setDealerMembershipType(memberType);
        const fd = memberType === "Vendor" || memberType === "VendorDiamond" || memberType === "VendorGemstone" ? 1 : memberType === "Retailer" || memberType === "Combined" ? 2 : 3;
        setForDealer(fd);
        handleGetVendorDropdownData(id);
        handleGetRetailerDropdownData(id);
        handleLoadMetalTypeData(id, fd, dataRangeFrom, dataRangeTo, [], []);
      }
    });
  };

  const handleGetVendorDropdownData = (id) => {
    ReportJewelryReportService.GetVendorDropdownList({ dealerId: id, reporttype: "Dealer" }).then((response) => {
      if (response.data.message === "Success") setVendorList(response.data.responseData);
    });
  };

  const handleGetRetailerDropdownData = (id) => {
    ReportJewelryReportService.GetRetailerDropdownList({ dealerId: id, reporttype: "Dealer" }).then((response) => {
      if (response.data.message === "Success") setRetailerList(response.data.responseData);
    });
  };

  const handleVendorChange = (values) => {
    setVendorIds(values);
    if (values.length === 0) {
      handleGetRetailerDropdownData(dealerId);
    } else {
      ReportJewelryReportService.ChangeRetailerList({ vendorIds: extractDealerIds(values).toString() }).then((response) => {
        if (response.data.message === "Success") setRetailerList(response.data.responseData);
      });
    }
  };

  const handleRetailerChange = (values) => {
    setRetailerIds(values);
    if (values.length === 0) {
      handleGetVendorDropdownData(dealerId);
    } else {
      ReportJewelryReportService.ChangeVendorList({ retailerIds: extractDealerIds(values).toString() }).then((response) => {
        if (response.data.message === "Success") setVendorList(response.data.responseData);
      });
    }
  };

  const handleLoadMetalTypeData = (dealerIdArg, forDealerArg, fromDate, toDate, vIds, rIds) => {
    setLoading(true);
    ReportJewelryReportService.GetMetalTypeData({
      dealerID: dealerIdArg.toString(),
      forDealer: forDealerArg ? forDealerArg.toString() : "",
      fromDate: moment(fromDate).format("YYYY-MM-DD"),
      toDate: moment(toDate).format("YYYY-MM-DD"),
      retailerIds: extractDealerIds(rIds).toString(),
      vendorIds: extractDealerIds(vIds).toString(),
      reporttype: "Dealer",
    })
      .then((response) => {
        setLoading(false);
        if (response.data.message === "Success" && response.data.responseData?.Table) {
          const rows = response.data.responseData.Table;
          setMetalTypeData(rows);
          setTotalClicks(rows.reduce((sum, row) => sum + Number(row.COUNT || 0), 0));
        } else {
          setMetalTypeData([]);
          setTotalClicks(0);
        }
      })
      .catch(() => {
        setLoading(false);
        setMetalTypeData([]);
        setTotalClicks(0);
      });

    setPriorTotalClicks(null);
    fetchPriorPeriodTotalClicks(
      ReportJewelryReportService.GetMetalTypeData,
      (pFrom, pTo) => ({
        dealerID: dealerIdArg.toString(),
        forDealer: forDealerArg ? forDealerArg.toString() : "",
        fromDate: pFrom,
        toDate: pTo,
        retailerIds: extractDealerIds(rIds).toString(),
        vendorIds: extractDealerIds(vIds).toString(),
        reporttype: "Dealer",
      }),
      fromDate,
      toDate,
      "COUNT"
    ).then(setPriorTotalClicks);
  };

  const onDateChange = (dates, dateStrings) => {
    if (dates) {
      setDataRangeFrom(dateStrings[0]);
      setDataRangeTo(dateStrings[1]);
    }
  };

  const handleApplyFilter = () => {
    setFilterMetalTypeId("");
    setFilterMetalColorId("");
    handleLoadMetalTypeData(dealerId, forDealer, dataRangeFrom, dataRangeTo, vendorIds, retailerIds);
    setRefetchToken((tok) => tok + 1);
  };

  const handleSliceClick = ({ metalTypeId, metalColorId }) => {
    // MetalTypeID/MetalColorID come off the chart's raw data row as numbers;
    // the backend's MetalType/MetalColorType fields are typed string, so a
    // bare number here fails model binding (400) and the table never updates.
    setFilterMetalTypeId(metalTypeId != null ? String(metalTypeId) : "");
    setFilterMetalColorId(metalColorId != null ? String(metalColorId) : "");
  };

  const handleDownloadChart = async () => {
    setPdfLoading(true);
    const vendorNames = vendorIds.length === 0 ? t("All Vendors") : vendorList.filter((v) => extractDealerIds(vendorIds).includes(v.dealerID.toString())).map((v) => v.dealerCompany).join(", ");
    const retailerNames = retailerIds.length === 0 ? t("All Retailers") : retailerList.filter((v) => extractDealerIds(retailerIds).includes(v.dealerID.toString())).map((v) => v.dealerCompany).join(", ");
    try {
      await exportChartPdf({
        elementId: "pdf-content",
        title: t(METAL_TYPE_CONFIG.pageTitle),
        dealerCompany: loginDetials?.loginDetials?.responseData?.dealerCompany,
        dealerId,
        dataRangeFrom,
        dataRangeTo,
        infoLines: [
          ...(dealerMembershipType !== "" && dealerMembershipType !== "Vendor" && dealerMembershipType !== "VendorDiamond" && dealerMembershipType !== "VendorGemstone" ? [`Vendors: ${vendorNames}`] : []),
          ...(dealerMembershipType !== "" && dealerMembershipType !== "Retailer" ? [`Retailers: ${retailerNames}`] : []),
          `Total Clicks: ${totalClicks}`,
        ],
        fileName: "Jewelry-Metal-Type-Report.pdf",
      });
    } finally {
      setPdfLoading(false);
    }
  };

  const handleDownloadActivityPdf = () => {
    let inputData = {
      dealerID: dealerId ? dealerId.toString() : "",
      forDealer: forDealer ? forDealer.toString() : "",
      fromDate: moment(dataRangeFrom).format("YYYY-MM-DD"),
      toDate: moment(dataRangeTo).format("YYYY-MM-DD"),
      retailerIds: extractDealerIds(retailerIds).toString(),
      vendorIds: extractDealerIds(vendorIds).toString(),
      reporttype: "Dealer",
      reportName: "MetalType",
      barViewDimensions: chartType === "bar" ? "MetalType" : "",
    };
    setActivityPdfLoading(true);
    ReportJewelryReportService.ExportMetricPdf(inputData)
      .then((response) => {
        setActivityPdfLoading(false);
        const filename = `Jewelry_MetalType_${dataRangeFrom}_${dataRangeTo}.pdf`;
        BlobToDownloadFile(response.data, filename, "pdf");
      })
      .catch(() => {
        setActivityPdfLoading(false);
        message.error(t("Failed to generate PDF. Please try again."));
      });
  };

  const validMetalTypes = metalTypeData.filter((row) => isValidMetalType(row.MetalType));
  const sortedMetalTypes = [...validMetalTypes].sort((a, b) => Number(b.COUNT || 0) - Number(a.COUNT || 0));
  const topMetalType = sortedMetalTypes[0];
  const validTotal = validMetalTypes.reduce((sum, row) => sum + Number(row.COUNT || 0), 0);
  const top3Sum = sortedMetalTypes.slice(0, 3).reduce((sum, row) => sum + Number(row.COUNT || 0), 0);
  const top3Pct = validTotal > 0 ? Math.round((top3Sum / validTotal) * 100) : 0;
  const topPct = validTotal > 0 && topMetalType ? ((Number(topMetalType.COUNT) / validTotal) * 100).toFixed(2) : 0;

  return (
    <ReportScaffold
      config={METAL_TYPE_CONFIG}
      report={{
        [METAL_TYPE_CONFIG.dataKey]: metalTypeData,
        JewelryTotalClicks: [{ TotalClickCnt: totalClicks }],
        JewelrySummaryKPIs: priorTotalClicks != null ? [{ Metric: "TotalClicks", CurrentValue: totalClicks, PriorValue: priorTotalClicks }] : [],
      }}
      loading={loading}
      dealerId={dealerId}
      forDealer={forDealer}
      dealerCompany={loginDetials?.loginDetials?.responseData?.dealerCompany}
      globalDiamonds={{ dataRangeFrom, dataRangeTo }}
      onDateChange={onDateChange}
      onApplyFilter={handleApplyFilter}
      refetchToken={refetchToken}
      onDownloadChart={handleDownloadChart}
      downloadingChart={pdfLoading}
      onDownloadActivityPdf={handleDownloadActivityPdf}
      downloadingActivityPdf={activityPdfLoading}
      onChartClick={handleSliceClick}
      onChartTypeChange={setChartType}
      insight={
        topMetalType && (
          <div className="edr-insight">
            💡 <b>{topMetalType.MetalType}</b> {t("leads metal preference at")} <b>{topPct}%</b>, {t("and the top 3 metal types capture")}{" "}
            <b>{top3Pct}%</b> {t("of engagement")} —{" "}
            {top3Pct > 70
              ? t("a highly concentrated preference worth reflecting in inventory mix.")
              : t("preference is reasonably spread across metal types.")}
          </div>
        )
      }
      extraFilterFields={
        <>
          {dealerMembershipType !== "" && dealerMembershipType !== "Vendor" && dealerMembershipType !== "VendorDiamond" && dealerMembershipType !== "VendorGemstone" && (
            <div className="col-md-3">
              <div className="input__block">
                <label>{t("Vendor(s)")}</label>
                <Select className="border__grey" showSearch showArrow mode="multiple" placeholder={t("Select One or More Vendors")} optionFilterProp="children" value={vendorIds} onChange={handleVendorChange}>
                  {vendorList.map((item) => (
                    <Option key={`vendor-${item.dealerID}`} value={`${item.dealerID}|${item.dealerCompany}`}>{item.dealerCompany}</Option>
                  ))}
                </Select>
              </div>
            </div>
          )}
          {dealerMembershipType !== "" && dealerMembershipType !== "Retailer" && (
            <div className="col-md-3">
              <div className="input__block">
                <label>{t("Retailer(s)")}</label>
                <Select className="border__grey" showSearch showArrow mode="multiple" placeholder={t("Select one or more retailer")} optionFilterProp="children" value={retailerIds} onChange={handleRetailerChange}>
                  {retailerList.map((item) => (
                    <Option key={`retailer-${item.dealerID}`} value={`${item.dealerID}|${item.dealerCompany}`}>{item.dealerCompany}</Option>
                  ))}
                </Select>
              </div>
            </div>
          )}
        </>
      }
      detailTable={
        <JewelryDetailSearchTable
          dealerId={dealerId}
          forDealer={forDealer}
          dataRangeFrom={dataRangeFrom}
          dataRangeTo={dataRangeTo}
          vendorIds={vendorIds}
          retailerIds={retailerIds}
          dealerMembershipType={dealerMembershipType}
          filterParamName={METAL_TYPE_CONFIG.detail.filterParamName}
          metalTypeId={filterMetalTypeId}
          metalColorId={filterMetalColorId}
          fileNamePart={METAL_TYPE_CONFIG.detail.fileNamePart}
          dealerCompany={loginDetials?.loginDetials?.responseData?.dealerCompany}
          refetchToken={refetchToken}
          title={t("Product Click Log")}
        />
      }
    />
  );
};

export default JewelryMetalTypeReportMain;
